module.exports = __webpack_public_path__ + "static/media/etna-head.05ea4549.png";